import PreviewComment, { IPreviewComment } from './PreviewComment';

export interface IPosition {
  id: string;
  num: number;
  x: number;
  y: number;
  comments: PreviewComment[];
}

class Position {
  public readonly id: string;
  public readonly num: number;
  public readonly x: number;
  public readonly y: number;
  public readonly comments: PreviewComment[];

  constructor({
    id,
    num,
    x,
    y,
    comments,
  }: {
    id: string;
    num: number;
    x: number;
    y: number;
    comments: PreviewComment[];
  }) {
    this.id = id;
    this.num = num;
    this.x = x;
    this.y = y;
    this.comments = comments;
  }

  public toJSON = () => ({
    id: this.id,
    x: this.x,
    y: this.y,
    comments: this.comments,
  });

  public static fromJSON = (json: IPosition): Position => {
    const { id, num, x, y, comments } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof num !== 'number') throw new Error('.num must be a number');
    if (typeof x !== 'number') throw new Error('.x must be a number');
    if (typeof y !== 'number') throw new Error('.y must be a number');

    const _comments = comments.map((comment: IPreviewComment) => {
      return PreviewComment.fromJSON(comment);
    });

    return new Position({
      id,
      num,
      x,
      y,
      comments: _comments,
    });
  };
}

export default Position;
